import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Sidebar.css";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`sidebar ${isOpen ? "open" : "collapsed"}`}>
      {/* Toggle Button inside sidebar */}
      <button className="sidebar-toggle" onClick={toggleSidebar}>
        {isOpen ? "✖" : "☰"}
      </button>

      <ul>
        <li>
          <Link to="/candidate/dashboard" className="sidebar-link">
            <img src={require('../../../img/UserProfile/Home.webp')} alt="Home Icon" className="icon" />
            <span>Home</span>
          </Link>
        </li>

        <li>
          <Link to="/candidate/dashboard/profile" className="sidebar-link">
            <img src={require('../../../img/Icons/Prf-Icon.webp')} alt="Profile Icon" className="icon" />
            <span>Profile</span>
          </Link>
        </li>


        <li>
          <Link to="/appliedjobs" className="sidebar-link">
            <img src={require('../../../img/UserProfile/checkmark.webp')} alt="Applied Jobs Icon" className="icon" />
            <span>Applied Jobs</span>
          </Link>
        </li>

        <li>
          <Link to="/candidate/dashboard/savedjobs" className="sidebar-link">
            <img src={require('../../../img/UserProfile/briefcase.webp')} alt="Saved Jobs Icon" className="icon" />
            <span>Saved Jobs</span>
          </Link>
        </li>

        <li>
          <Link to="/candidate/dashboard/airecommended" className="sidebar-link">
            <img src={require('../../../img/UserProfile/AI-recomended.webp')} alt="AI Recommended Icon" className="icon" />
            <span>AI Recommended</span>
          </Link>
        </li>
        <li>
          <Link to="/candidate/dashboard/skillsgap" className="sidebar-link">
            <img src={require('../../../img/UserProfile/Skill.webp')} alt="Skills Gap Icon" className="icon icon-gray" />
            <span>Skills Gap</span>
          </Link>
        </li>


      </ul>
    </div>
  );
};

export default Sidebar;
